/**
 * Payment links on the phone: labels, the prefilled "new link" address other screens open, and the
 * amount as typed. The link itself is made by the backend (lib/hq/payment-links.ts in Medusa).
 */
import { localized } from "./i18n"
import type { PaymentLinkKind } from "./medusa"

// The owners' own words for the kinds, the same in both languages (2026-09-27).
export const KIND_LABEL: Record<PaymentLinkKind, string> = { deposit: "Προκαταβολή", balance: "Εξόφληση", other: "Άλλο" }
export const KIND_HINT: Record<PaymentLinkKind, string> = localized({
  deposit: "For a new custom order.",
  balance: "What is left, before shipping or handing over.",
  other: "Any other amount: a stock item, a difference, anything.",
})

/** One per opening of the form, so a retried Create returns the same link. */
export function newRequestId(): string {
  const random = typeof crypto !== "undefined" && "randomUUID" in crypto ? crypto.randomUUID().replace(/-/g, "") : Math.random().toString(36).slice(2) + Date.now().toString(36)
  return `hq-${random.slice(0, 32)}`
}

/** "69", "69,5", "69.50 €" → 69.5; "" → null; nonsense → NaN. */
export function parseAmount(text: string): number | null {
  const cleaned = text.replace(/€/g, "").replace(",", ".").trim()
  if (!cleaned) return null
  const n = Number(cleaned)
  return Number.isFinite(n) ? Math.round(n * 100) / 100 : NaN
}

export type LinkPrefill = { kind?: PaymentLinkKind; order?: string | null; amount?: number | null; handle?: string | null; title?: string | null }

/** Where the Payment links page opens with the form filled in, from an order or a parcel. */
export function newLinkUrl(prefill: LinkPrefill): string {
  const q = new URLSearchParams({ new: "1" })
  if (prefill.kind) q.set("kind", prefill.kind)
  if (prefill.order) q.set("order", prefill.order)
  if (prefill.amount != null && prefill.amount > 0) q.set("amount", String(prefill.amount))
  if (prefill.handle) q.set("handle", prefill.handle.replace(/^@/, ""))
  if (prefill.title) q.set("title", prefill.title)
  return `/payments?${q.toString()}`
}
